import React from 'react';
import { ShieldCheck, Zap, Download, MonitorSmartphone } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 bg-transparent" data-id="element-70">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-71">
        <div className="glass-card rounded-3xl p-8 md:p-12 text-center border-orange-500/20" data-id="element-72">
          <div className="w-16 h-16 mx-auto bg-orange-500/10 rounded-full flex items-center justify-center mb-6" data-id="element-73">
            <ShieldCheck className="w-8 h-8 text-orange-500" data-id="element-74" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-75">
            Compra con confianza
          </h2>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-76">
            Accedes a un recurso digital diseñado para acompañarte en tu
            práctica profesional con materiales organizados, aplicables y listos
            para usar.
          </p>

          <div className="flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-77">
            <div className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-78">
              <Zap className="w-5 h-5 text-orange-500" data-id="element-79" /> Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-80">
              <Download className="w-5 h-5 text-orange-500" data-id="element-81" /> Formato digital
            </div>
            <div className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-82">
              <ShieldCheck className="w-5 h-5 text-orange-500" data-id="element-83" /> Pago único
            </div>
            <div className="flex items-center gap-2 text-gray-300 font-medium" data-id="element-84">
              <MonitorSmartphone className="w-5 h-5 text-orange-500" data-id="element-85" /> Uso
              práctico profesional
            </div>
          </div>
        </div>
      </div>
    </section>;
}